const defaultSettings = {
    label: '',
    dataUrl: '',
    forceReload: false,
    cacherTimeout: 15, // minutes
    cacherPath: "https://host.daytondailynews.com/cop/digital/common/cache/cacher.php?",
    fileGetPath: "https://host.daytondailynews.com/cop/digital/common/php/simple_get_file.php?url="
}

export class CacherClass {

    constructor(settings = {}) {
        Object.assign(this, defaultSettings, settings);
    }

    createCacherUrl() {
        // INIT
        const vm = this;
        let cacherUrl = vm.cacherPath;

        // APPEND LABEL
        cacherUrl += "saveas=" + vm.label;

        // CHECK FORCE RELOAD
        if(vm.forceReload) { cacherUrl += "&force_reload=true"; }

        // CHECK CACHE TIMEOUT
        if(vm.cacherTimeout) { cacherUrl += "&max_cache_lifetime=" + vm.cacherTimeout; }

        // APPEND DATA SOURCE URL (ENCODED)
        cacherUrl += "&json_url=" + encodeURIComponent(vm.dataUrl);

        // RETURN CACHER URL
        return cacherUrl;
    }

    createFileGetUrl() {
        // INIT
        const vm = this;

        // CREATE AND RETURN
        return vm.fileGetPath + encodeURIComponent(vm.dataUrl);
    }

}